import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import APIKit from "../../config/APIKit";

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await APIKit.get(`/category/list`);
      return response.data;
    } catch (error) {
      if (error && typeof error === "object" && error.response) {
        return rejectWithValue(error.response?.data || "Categories get failed");
      }
      return rejectWithValue("Categories get failed");
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categories: null,
    status: "idle",
    error: null ,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchCategories.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categories = action.payload.data || action.payload;
        state.error = null;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "categories get failed";
      });
  },
});

export default categoriesSlice.reducer;
